<template>
  <v-data-table
    fixed-header
    :headers="headers"
    :loading="loading"
    :hide-default-footer="translatedContents?.length < 10"
    :items="translatedContents"
  >
    <template
      v-if="$vuetify.breakpoint.smAndUp"
      #item="i"
    >
      <tr>
        <td
          v-for="(column, index) in headers"
          :key="`column-${index}`"
          :class="mainColumns.includes(column.value) ? 'font-weight-bold' : ''"
        >
          <span v-if="column.value === 'questionnaire_contents'">
            <v-btn
              v-if="i.item.questionnaire_contents.find(el => el.fc_flg === 0)"
              fill
              small
              color="primary white--text"
              class="my-2 mr-2 text-start"
              @click="onQuestionnaireButtonClick(i.item.questionnaire_contents, 0)"
            >
              {{ $t("common.pre_course") }}
            </v-btn>
            <v-btn
              v-if="i.item.questionnaire_contents.find(el => el.fc_flg === 1)"
              fill
              small
              color="primary white--text"
              class="my-2 text-start"
              @click="onQuestionnaireButtonClick(i.item.questionnaire_contents, 1)"
            >
              {{ $t("common.post_course") }}
            </v-btn>
          </span>
          <span v-else>
            {{ i.item[column.value] }}
          </span>
        </td>
      </tr>
    </template>
    <template
      v-else
      #[`item.questionnaire_contents`]="{ item }"
    >
      <v-btn
        v-if="item.questionnaire_contents.find(el => el.fc_flg === 0)"
        fill
        color="primary white--text"
        class="my-2 text-start"
        small
        @click="onQuestionnaireButtonClick(item.questionnaire_contents, 0)"
      >
        {{ $t("common.pre_course") }}
      </v-btn>
      <v-btn
        v-if="item.questionnaire_contents.find(el => el.fc_flg === 1)"
        fill
        small
        color="primary white--text"
        class="my-2 text-start"
        @click="onQuestionnaireButtonClick(item.questionnaire_contents, 1)"
      >
        {{ $t("common.post_course") }}
      </v-btn>
    </template>
  </v-data-table>
</template>

<script>
import { japaneseDateFormat } from '../../../plugins/japaneseDateFormat'

export default {
  name: 'SeminarDetailTable',
  props: {
    /**
     * @desc headers of the table
     * *note* header value should match with the content table, otherwise need to add more condition to generate the
     * correct content
     * @see arrangeApexATCSeriesDataTableContents
     */
    headers: {
      required: true,
      type: Array
    },
    /**
     * @desc content which will be display
     */
    contents: {
      required: true,
      type: Array
    },
    /**
     * @desc the loading state of the table
     */
    loading: {
      required: true,
      type: Boolean
    },
    /**
     * @desc main column of the table which will display in bold
     */
    mainColumns: {
      required: false,
      type: Array,
      default: () => []
    }
  },
  computed: {
    translatedContents() {
      return this.arrangeApexATCSeriesDataTableContents(this.contents, this.headers)
    }
  },
  methods: {
    japaneseDateFormat,

    onQuestionnaireButtonClick(data, flg) {
      const item = data.find(x => x.fc_flg === flg)
      this.$router.push({ name: 'CourseReportDetail', params: { seminar_id: item.seminar_id, customer_id: item.id, fc_flg: item.fc_flg }})
    },

    /**
     * @desc function to generate content from table header.
     * Match the header value and the given content object key, so we don't need to add any condition unless we need to
     * modify data before showing on UI which we definitely need to add more conditions manually
     * @param contents given content to show inside the table
     * @param headers header of the table which pass from a parent component
     * @returns {*}
     */
    arrangeApexATCSeriesDataTableContents (contents, headers) {
      return contents.map((content, index) => {
        const dataTable = {}
        headers.forEach(header => {
          if(header.value === 'attendance_status') {
            dataTable['attendance_status'] = content.attend_division_id === 2 ? `${this.$t('employee_seminar_detail.attended')}: ${content.start_date.replace(/-/g, '/')}` : `- : ${content.start_date.replace(/-/g, '/')}`
          } else if(header.value === 'attended_count') {
            dataTable['attended_count'] = index === 0 ? this.$t('employee_seminar_detail.first_attend') : this.$t('employee_seminar_detail.reattended', {index: index})
          } else if(header.value === 'schedule') {
            dataTable['schedule'] = this.$i18n.locale === 'jp' ? this.japaneseDateFormat(content.start_date) : content.start_date.replace(/-/g, '/')
          } else {
            dataTable[header.value] = content[header.value]
          }
        })
        return dataTable
      })
    },
  }
}
</script>

<style scoped>
th:not(:last-child), td:not(:last-child) {
  border-right: 1px solid #e0e0e0;
}
::v-deep .v-data-table__mobile-row__header {
  width: 40%;
  padding-bottom: 8px;
  padding-top: 8px;
}
::v-deep .v-data-table__mobile-row__cell {
  width: 60%;
}
::v-deep .seminar-dialog-table-header,
::v-deep .seminar-dialog-table-header-last {
  background: #f9f9f9 !important;
  border: 0 solid #eaeaea !important;
  font-weight: 900 !important;
  color: #101010 !important;
  font-size: 12px !important;
  border-top: 1px solid #eaeaea !important;
}

::v-deep .seminar-dialog-table-header {
  border-right-width: 1px !important;
}
</style>
